import FuseSplashScreen from '@fuse/core/FuseSplashScreen';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from '@reduxjs/toolkit';
import Request from 'app/base/request';
import { setUserInfo, updatePercent } from './store/userSlice';
import { changeLanguage } from 'app/store/i18nSlice';
import { setNavigation } from 'app/store/fuse/navigationSlice';
import navigationConfig from 'app/fuse-configs/navigationConfig';
import { progress } from 'app/common-apis/file';
import { Language } from 'app/util/consts';
import { getKeyByValue } from 'app/util/utils';
import { REFRESH_TOKEN_ENDPOINT, REFRESH_TOKEN_KEY, TOKEN_KEY } from 'app/util/consts';
import { sleep, saveCookie, getCookie, getStaticDataUrl } from 'app/util/utils';
import api from 'app/base/axios';
class Auth extends Component {
	state = {
		waitAuthCheck: false,
		intervalId: 0
	};

	componentWillReceiveProps = nextProps => {
		// if (nextProps.hasUploading && !this.props.hasUploading)
		//     this.resetUploadInterval();
		if (nextProps.needUserInfo && this.props.redirectOn401 !== nextProps.redirectOn401 && getCookie(REFRESH_TOKEN_KEY)) {
			this.setState({ ...this.state, waitAuthCheck: true });
			try {
				api.get('user/me').then(
					res => {
						if (res.status >= 300) throw Error('refresh token expired')
						this.props.setUserInfo(res?.data);
						if (window.dataLayer) {
							window.dataLayer.push({
								'event': 'login',
								'user_id': res?.data.id
							});
							console.log('window.dataLayer',window.dataLayer);
						}
						// this.props.changeLanguage(getKeyByValue(Language, userInfo.language).toLowerCase());
						const condition = conf =>
							(conf.forLoggedIn === undefined || conf.forLoggedIn) &&
							(conf.isPublic || res?.data.features.some(feat => feat.feature.code.startsWith(conf.id))) &&
							(['item', 'link'].includes(conf.type) || conf.children.length > 0);
						let nav = navigationConfig
							.map(function fun(conf) {
								let _conf = { ...conf };
								if (conf.children) _conf.children = conf.children.map(fun).filter(condition);
								return _conf;
							})
							.filter(condition);
						this.props.setNavigation(nav);
						this.setState({ waitAuthCheck: false });
					}
				).catch(error => {
					let nav = navigationConfig
						.filter(conf => !conf.forLoggedIn)
						.map(function fun(conf) {
							let _conf = { ...conf };
							if (conf.url) _conf.url = (conf.freePreUrl || '') + conf.url;
							if (conf.children) _conf.children = conf.children.filter(conf => !conf.forLoggedIn).map(fun);
							return _conf;
						});
					this.props.setNavigation(nav);
					this.setState({ ...this.state, waitAuthCheck: false });
				});
			} catch (error) {
				console.log(error);
			}

		}
	};

	resetUploadInterval() {
		clearInterval(this.state.intervalId);
		let intervalId = setInterval(() => {
			if (!this.props.uploadedLargeFiles.some(f => f.percent !== 100)) {
				clearInterval(this.state.intervalId);
				return;
			}
			this.props.uploadedLargeFiles
				.filter(f => f.percent !== 100)
				.forEach(item => {
					progress(item.guid).then(
						res => {
							this.props.updatePercent({ guid: item.guid, percent: res });
						},
						error => { }
					);
				});
		}, 5000);
		this.setState({ ...this.state, intervalId: intervalId });
	}
	render() {
		return this.state.waitAuthCheck ? <FuseSplashScreen /> : <>{this.props.children}</>;
	}
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			setUserInfo,
			setNavigation,
			updatePercent,
			changeLanguage
		},
		dispatch
	);
}

const mapStateToProps = state => ({
	needUserInfo: state.fuse.settings.current.layout.config.needUserInfo,
	redirectOn401: state.fuse.settings.current.layout.config.redirectOn401,
	hasUploading: state.auth.user.hasUploading,
	uploadedLargeFiles: state.auth.user.uploadedLargeFiles
});

export default connect(mapStateToProps, mapDispatchToProps)(Auth);
